import { render, staticRenderFns } from "./AccountingLoanDrawdownDetail.vue?vue&type=template&id=24ad4685&"
import script from "./AccountingLoanDrawdownDetail.vue?vue&type=script&lang=js&"
export * from "./AccountingLoanDrawdownDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports